import React, { useState } from 'react';
import { Info, Settings } from 'lucide-react';
import SVGColorBlock from '../SVGColorBlock';
import SystemEditor from '../SystemEditor';
import CurrentOutputPanel from './CurrentOutputPanel';

function SystemPageHeader({ currentSystem, title, subtitle }) {
	const [editingSystemSettings, setEditingSystemSettings] = useState(false);

	if (!currentSystem) return null;

	return (
		<>
			<div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-4 sm:mb-6 pb-4 sm:pb-6 border-b border-gray-200 dark:border-gray-700">
				<div className="min-w-0 flex-1">
					<div className="flex flex-wrap items-center gap-2 sm:gap-3">
						<h1 className="text-xl sm:text-2xl font-semibold tracking-tight text-gray-900 dark:text-gray-100">
							{title || currentSystem.name || currentSystem.uid}
						</h1>
						{currentSystem.location && (
							<span className="text-xs sm:text-sm px-2.5 sm:px-3 py-0.5 sm:py-1 bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 rounded-full truncate max-w-full">
								{currentSystem.location}
							</span>
						)}
						<SVGColorBlock
							size={28}
							data={(currentSystem.color || []).length ? currentSystem.color : [{ r: 80, g: 80, b: 80 }]}
						/>
					</div>
					{subtitle && (
						<p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{subtitle}</p>
					)}
					<div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs sm:text-sm text-gray-500 mt-1">
						<Info size={14} className="shrink-0" />
						<span className="truncate">{currentSystem.name || currentSystem.uid}</span>
						{currentSystem.timezone && (
							<span className="hidden sm:inline">· {currentSystem.timezone}</span>
						)}
					</div>
				</div>
				<button
					onClick={() => setEditingSystemSettings(true)}
					className="p-2 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400 transition-colors shrink-0 self-start"
					title="System settings"
				>
					<Settings size={16} />
				</button>
			</div>

			<CurrentOutputPanel currentSystem={currentSystem} />

			{editingSystemSettings && (
				<SystemEditor
					open={editingSystemSettings}
					system={currentSystem}
					newsystem={false}
					onClose={() => setEditingSystemSettings(false)}
				/>
			)}
		</>
	);
}

export default SystemPageHeader;
